import { useEffect, useState } from "react";
import { AppBar } from "../MUIStyled/StyledAppBar";
import { Toolbar, Typography, Button, useMediaQuery } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import IconButton from "@mui/material/IconButton";
import HelpButtonModal from "../Help/HelpButtonModal";
import "./AppBar.css";

const BrowserAppBar = ({
 withAdaptations,
 setWithAdaptations,
 setChecked,
 checked,
}) => {
 // for help modal
 const [open, setOpen] = useState(false);

 const isSmallScreen = useMediaQuery("(max-width: 912px)");
 const isTinyScreen = useMediaQuery("(max-width: 300px)");

 const handleClickOpen = () => {
  setOpen(true);
 };

 useEffect(() => {
  if (!!withAdaptations && !!!checked) {
   setWithAdaptations(false);
  }
 }, [checked]);

 return (
  <AppBar className="appbar-top" position="fixed">
   <div className="appbar-container">
    <Toolbar className="row toolbar-top" disableGutters>
     {/* wide desktop view */}
     <div className="row start-center logo-container toolbar-item outside-container">
      {isSmallScreen ? (
       <>
        <a href="https://www.resilientbroward.com/">
         <img
          className="broward-logo"
          alt="broward-county-logo"
          src="broward-county-logo-1.png"
         />
        </a>
       </>
      ) : (
       <>
        <a href="https://www.resilientbroward.com/">
         <img
          className="broward-logo"
          alt="broward-county-logo"
          src="broward-county-logo-1.png"
         />
        </a>
        <Typography className="app-title" variant="h6" noWrap component="div">
         Scenario Viewer
        </Typography>
       </>
      )}
     </div>
     <div className="row center-center toolbar-item ">
      {!!isSmallScreen ? (
       <>
        {isTinyScreen ? (
         <Typography
          className="app-title"
          variant="subtitle1"
          noWrap
          component="div"
         >
          Scenario Viewer
         </Typography>
        ) : (
         <Typography className="app-title" variant="h6" noWrap component="div">
          Scenario Viewer
         </Typography>
        )}
       </>
      ) : (
       <></>
      )}
     </div>
     <div className="row end-center search-container toolbar-item outside-container">
      {isSmallScreen ? (
       <>
        <div className="search-widget-box" id="searchWidgetBox">
         <div className="search-widget-container" id="searchWidget"></div>
        </div>
        <Button
         variant="outlined"
         aria-label="help"
         aria-controls="menu-appbar"
         aria-haspopup="true"
         onClick={handleClickOpen}
         color="inherit"
        >
         Help
        </Button>
       </>
      ) : (
       <>
        <div className="search-widget-box" id="searchWidgetBox">
         <div className="search-widget-container" id="searchWidget"></div>
        </div>
        <Button
         variant="outlined"
         aria-label="help"
         aria-controls="menu-appbar"
         aria-haspopup="true"
         onClick={handleClickOpen}
         color="inherit"
        >
         Help
        </Button>
        {/* <IconButton
         size="large"
         aria-label="help"
         aria-controls="menu-appbar"
         aria-haspopup="true"
         onClick={handleClickOpen}
         color="inherit"
        >
         <HelpIcon fontSize="large" />
        </IconButton> */}
       </>
      )}
     </div>
    </Toolbar>
   </div>
   <HelpButtonModal open={open} setOpen={setOpen} />
  </AppBar>
 );
};

export default BrowserAppBar;
